import { Fragment } from 'react';
import { Col } from "reactstrap";
import ComplainItemLoader from "./ComplainItemLoader";



const ComplainPageLoader = ({ count = 12 }) => {
    return (
        <Fragment>
            {Array.from(Array(count), (v, k) =>
                <Col key={k} md="6" xl="4"><ComplainItemLoader /></Col>
            )}
        </Fragment>
    );
};

export default ComplainPageLoader;